import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getDataAccesses = async (token, params, municipalityId) => {
  const url = `municipalities/${municipalityId}/data_access`
  const data = await apiGet({ url, params, token })
  return data
}

export function useDataAccesses({ params, options }) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const queryFn = () => getDataAccesses(token, params, municipality_id)
  const queryKey = ['data-access', params]
  return useQuery(queryKey, queryFn, { ...options })
}

const getDataAccess = async (token, id, municipality_id) => {
  const url = `data_access/${id}?municipality_id=${municipality_id}`
  const data = await apiGet({ url, token })
  return data
}

export function useDataAccess({ params, options }) {
  const id = params.id
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const queryFn = () => getDataAccess(token, id, municipality_id)
  const queryKey = ['data-access', id]
  return useQuery(queryKey, queryFn, { ...options })
}
